module.exports = __webpack_public_path__ + "static/media/chat_supervisor.f90e0b29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SupervisorChat/chat_supervisor.svg
// module id = 1834
// module chunks = 0